export const press = [
	{
		name: 'Vanguard',
		logo: 'https://res.cloudinary.com/dqyhh2jit/image/upload/v1626177468/safeup/press/vanguard_enp90l.svg',
		article: 'https://www.vanguardngr.com/2021/04/project-safeup-distributes-1m-ppe/',
		screenshot: 'https://res.cloudinary.com/dqyhh2jit/image/upload/v1626302241/safeup/press/brandcrunch_gxahq1.png',
	},
	{
		name: 'Business Day',
		logo: 'https://res.cloudinary.com/dqyhh2jit/image/upload/v1626177468/safeup/press/business-day_w1nsy8.svg',
		article:
			'https://businessday.ng/companies/article/my-world-of-bags-mastercard-launch-project-safeup-distributes-2-5-million-ppe/',
		screenshot: 'https://res.cloudinary.com/dqyhh2jit/image/upload/v1626302241/safeup/press/brandcrunch_gxahq1.png',
	},
	{
		name: 'Punch',
		logo: 'https://res.cloudinary.com/dqyhh2jit/image/upload/v1626179686/safeup/press/punch_h2adwg.svg',
		article: 'https://punchng.com/project-safeup-raises-awareness-on-covid-19/',
	},
	{
		name: 'Neusroom',
		logo: 'https://res.cloudinary.com/dqyhh2jit/image/upload/v1626181389/safeup/press/neusroom_socw1z.svg',
		article: 'https://neusroom.com/tag/project-safeup/',
	},
	{
		name: 'The Guardian',
		logo: 'https://res.cloudinary.com/dqyhh2jit/image/upload/v1626177469/safeup/press/the-guardian_khfnyx.svg',
		article: 'https://guardian.ng/news/project-safeup-to-provide-free-2-5m-ppe-to-nigerians/',
	},
	{
		name: 'The Nation',
		logo: 'https://res.cloudinary.com/dqyhh2jit/image/upload/v1626179686/safeup/press/punch_h2adwg.svg',
		article: 'https://thenationonlineng.net/project-safeup-takes-covid-19-awareness-to-the-grassroots/',
	},
	{
		name: 'The Daily Trust',
		logo: 'https://res.cloudinary.com/dqyhh2jit/image/upload/v1626179686/safeup/press/punch_h2adwg.svg',
		article: 'https://dailytrust.com/project-safeup-distributes-1-million-ppes-in-5-months',
	},
	{
		name: 'Brandcrunch',
		logo: 'https://res.cloudinary.com/dqyhh2jit/image/upload/v1626181210/safeup/press/brandcrunch_u99dov.svg',
		article: 'https://www.brandcrunch.com.ng/2021/04/27/project-safeup-distributes-1-million-ppe-items-in-five-months/',
		screenshot: 'https://res.cloudinary.com/dqyhh2jit/image/upload/v1626302241/safeup/press/brandcrunch_gxahq1.png',
	},
];
